module.exports = __webpack_public_path__ + "img/success.97538b06.svg";